module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"sortBy":"Sort By","mostPopular":"Most Popular","priceLowToHigh":"By Price From Low To High","priceHighToLow":"By Price From High To Low"},"ar":{"sortBy":"ترتيب","mostPopular":"الأكثر شيوعا","priceLowToHigh":"حسب السعر من الاقل للأكبر","priceHighToLow":"حسب السعر من الاكبر للأقل"}}')
  delete Component.options._Ctor
}
